export default __webpack_public_path__ + "static/media/logo.01bad6cf.png";